import React, { useState } from "react";

// Session-scoped map: persists collapsed state across re-mounts within the same browser session
const chapterCollapseState = new Map<string, boolean>();

export function ToolbarChapter(props: { children: any; title: string }): any {
  const { children, title } = props;
  // Initialize from session map so state survives re-renders/re-mounts
  const [collapsed, setCollapsed] = useState(() => chapterCollapseState.get(title) ?? false);

  const toggle = () => {
    setCollapsed((c) => {
      const next = !c;
      chapterCollapseState.set(title, next);
      return next;
    });
  };

  return (
    // Add "collapsed" CSS class when folded so the chapter shrinks via flex-grow:0
    <div className={`chapter${collapsed ? " collapsed" : ""}`}>
      {/* Landscape title: 3-item flex row — spacer | text | arrow icon */}
      <div className="title landscape" onClick={toggle}>
        {/* Left spacer mirrors the icon width so the text stays truly centered */}
        <span className="title-spacer" />
        <span className="title-text">{title}</span>
        <span className="title-icon">
          {/* Arrow direction indicates collapsed state */}
          <i className={`las ${collapsed ? "la-angle-down" : "la-angle-up"}`} />
        </span>
      </div>
      {/* Hide items when collapsed */}
      {!collapsed && (
        <div className="items" style={{ flexDirection: children.length == 1 ? "column" : undefined }}>
          {" "}
          {children}
        </div>
      )}
      {/* Portrait title (shown instead of landscape title on narrow screens) */}
      <div className="title portrait" onClick={toggle}>
        <span className="title-spacer" />
        <span className="title-text">{title}</span>
        <span className="title-icon">
          <i className={`las ${collapsed ? "la-angle-right" : "la-angle-down"}`} />
        </span>
      </div>
    </div>
  );
}
export function ToolbarRoomChapter(props: { children: any; title: string }): any {
  const { children, title } = props;

  return (
    <div className="chapter">
      <div className="title landscape">{title}</div>
      <div className="items" style={{ flexDirection: "column" }}>
        {" "}
        {children}
      </div>
      <div className="title portrait">{title}</div>
    </div>
  );
}
